export default __webpack_public_path__ + "static/media/logo_parc_expo.6358134f.svg";